<template>
	<div class="shop qjc-relative">
		<div class="left qjc-absolute">
			<img @click="$router.push('/dayu/course')" class="qjc-wid-100 qjc-hei-100" src="../../../assets/images/dayu_shop_left.png" alt="大禹惠康课程表">
		</div>
		<div class="center qjc-absolute" ref="center">
			<iframe :style="{ width: centerWidth>maxWidth?maxWidth+'px':'100%', transform: 'scale('+ (centerWidth>maxWidth?(centerWidth/maxWidth):1) +')' }" height="100%" src="https://shop45145934.m.youzan.com/v2/showcase/homepage?alias=nNubVDg1wp&dc_ps=2588846330684176393.300001" frameborder="0"></iframe>
		</div>
		<div class="right qjc-absolute">
			<img class="qjc-wid-100 qjc-hei-100" src="../../../assets/images/dayu_shop_right.png" alt="">
			<img class="suspend qjc-absolute" src="../../../assets/images/dayu_shop_suspend.png"/>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'dayuShop',
		data() {
			return {
				maxWidth: /Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/i.test(navigator.userAgent)?540:375,
				centerWidth: 0,
				iframeBottom: 0
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.centerWidth = this.getCenterWidth();
			})
		},
		methods: {
			getCenterWidth() {
				return 800/1920*document.documentElement.clientWidth;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.shop{
		height: 9.9rem;
		overflow: hidden;
		
		.left,
		.right{
			width: 5.6rem;
			top: 0;
			bottom: 0;
			z-index: 100;
		}
		
		.left{
			left: 0;
		}
		.right{
			right: 0;
			
			.suspend{
				left: 0.43rem;
				bottom: 1.33rem;
				width: 3.14rem;
				height: 5.52rem;
				color: #808080;
				border-radius: 0.08rem;
				background-color: #fff;
				border: 0.01rem solid #ccc;
				line-height: 0.24rem;
				padding: 0.2rem 0.16rem;
				box-shadow: 0px 0.1rem 0.3rem 0px rgba(77, 91, 124, 0.3);
				
				
			}
		}
		
		.center{
			top: 0;
			left: 50%;
			bottom: 0;
			width: 8rem;
			transform: translateX(-50%);
			box-shadow: 0 0.02rem 0.3rem 0 rgba(38, 45, 62, 0.5);
			overflow-y: auto;
			z-index: 200;
			
			iframe{
				transform-origin: 0 0;
			}
		}
	}
</style>
